import { Component, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';

import { TimeReportService } from '../../../services/time-report.service';

declare var $: any;

@Component({
  selector: 'app-attendance-time-summary',
  templateUrl: './attendance-time-summary.component.html',
  styleUrls: ['./attendance-time-summary.component.css']
})
export class AttendanceTimeSummaryComponent implements OnInit {
  
  attendanceTimeSummaryPanelList = [];
  toDate: string;
  
  constructor(
    private timeReportService: TimeReportService,
    private datePipe: DatePipe
  ) { }

  ngOnInit() {
    let $this = this;
    let date = new Date();
    let preDate = date.setDate(date.getDate() - 1);
    this.toDate = this.datePipe.transform(preDate, 'yyyy-MM-dd');
    $('.allocationDate').val(this.datePipe.transform(preDate, 'yyyy-MM-dd'));
    $('.allocationDate').datepicker({
      autoclose: true,
      minViewMode: 0,
      format: 'yyyy-mm-dd',
      endDate: new Date()
    }).on('changeDate', function (selected) {
      let selectDate = new Date(selected.date.valueOf());
      $this.toDate = $this.datePipe.transform(selectDate, 'yyyy-MM-dd');
      $this.getAttendanceTimeSummary();
    });
    this.getAttendanceTimeSummary();
  }

  getAttendanceTimeSummary(){
    let body = {toDate: this.toDate};
    this.timeReportService.getAttendanceTimeSummary(body).subscribe(
      timeSummary => {
        this.attendanceTimeSummaryPanelList = [
          {
            valiedHeader:"Attendance ( >= 8.5 )",
            validSummaryList: timeSummary.data.attendance_sheets.valid_attendance,
            invaliedHeader:"Attendance ( < 8.5 )",
            invalidSummaryList: timeSummary.data.attendance_sheets.invalid_attendance
          },
          {
            valiedHeader:"Work time ( >= 8.0 )",
            validSummaryList: timeSummary.data.time_sheets.valid_time,
            invaliedHeader:"Work time ( < 8.0 )",
            invalidSummaryList: timeSummary.data.time_sheets.invalid_time
          }
        ];
      }
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/time/components/reports/attendance-time-summary/attendance-time-summary.component.ts